import React, { Fragment } from "react";

const Ifbr = ({ element }) => {

    if (!element) {
        return '';
    } else {
        return (
            <>
                {element}<br />
            </>
        );
    }
};

export default Ifbr;
